import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { Placeholder } from "rsuite";
import * as customerReportService from "../../../services/customerReport.service";

const CustomerChart = ({ filter, From }) => {
    const [customerChartData, setCustomerChartData] = useState([]);
    const [loadingCustomer, setLoadingCustomer] = useState(true);

    useEffect(() => {
        if (From === "CustomerReport") {
            setLoadingCustomer(true);
            customerReportService.chart(filter)
                .then((res) => {
                    setCustomerChartData(res.data || []);
                    setTimeout(() => setLoadingCustomer(false), 500);
                })
                .catch((err) => {
                    console.error("Error:", err);
                    setLoadingCustomer(false);
                });
        }
    }, [filter, From]);

    const categories = customerChartData.map(d => {
        const date = new Date(d._id);
        return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
    });

    const commonYAxis = {
        min: 0,
        forceNiceScale: true,
        labels: { formatter: (val) => Math.floor(val) }
    };

    const areaOptions = {
        chart: { type: "area", toolbar: { show: false } },
        stroke: { curve: "smooth", width: 3 },
        colors: ["#10B981"],
        markers: { size: 5, colors: ["#fff"], strokeColors: "#10B981", strokeWidth: 3 },
        xaxis: { categories: categories, title: { text: "Date" } },
        yaxis: commonYAxis,
        grid: { strokeDashArray: 5 }
    };

    const barOptions = {
        chart: { type: 'bar', toolbar: { show: false } },
        plotOptions: { bar: { borderRadius: 8, columnWidth: '30%' } },
        fill: {
            type: 'gradient',
            gradient: {
                gradientToColors: ['#8E54E9'],
                colorStops: [
                    { offset: 0, color: "#D1C4E9", opacity: 1 },
                    { offset: 100, color: "#4776E6", opacity: 1 }
                ]
            }
        },
        xaxis: { categories: categories },
        yaxis: commonYAxis
    };

    if (loadingCustomer) return <Placeholder.Paragraph rowHeight={400} active rows={1} />;

    return (
        <div className="row">
            {/* <div className="col-xl-6 col-lg-6 col-md-12">
                <div className="card custom-card bg-white p-4 shadow-sm mb-3" style={{ borderRadius: "11px" }}>
                    <h6 className="main-content-label mb-3 text-uppercase">Customer Registrations</h6>
                    <Chart options={areaOptions} series={[{ name: "Customers", data: customerChartData.map(d => d.total_customers || 0) }]} type="area" height={350} />
                </div>
            </div> */}
            <div className="col-12"> {/* full width on all screen sizes */}
                <div
                    className="card custom-card bg-white p-4 shadow-sm mb-3"
                    style={{ borderRadius: "11px" }}
                >
                    <h6 className="main-content-label mb-3 text-uppercase">
                        Customer Registrations
                    </h6>
                    <Chart
                        options={areaOptions}
                        series={[{ name: "Customers", data: customerChartData.map(d => d.total_customers || 0) }]}
                        type="area"
                        height={350}
                        width="100%" // ensures chart spans full width
                    />
                </div>
            </div>
            {/* <div className="col-xl-6 col-lg-6 col-md-12">
                <div className="card custom-card bg-white p-4 shadow-sm mb-3" style={{ borderRadius: "11px" }}>
                    <h6 className="main-content-label mb-3 text-uppercase">Customer Activity</h6>
                    <Chart options={barOptions} series={[{ name: "New", data: customerChartData.map(d => d.total_customers || 0) }]} type="bar" height={350} />
                </div>
            </div> */}
        </div>
    );
};

export default CustomerChart;